import { Colors } from '@sigma-frontend-libs/commons'

import { components, eventHandlers, popperPlacements } from '@/utils'

import render from './render'

export default {
  name: 'ButtonToolbar',

  mixins: [ eventHandlers ],

  props: {
    icon: String,
    iconSVG: String,
    tooltip: String,

    color: {
      type: String,
      default: Colors.white,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    }
  },

  computed: {
    $directives() {
      const result = []
      if (this.tooltip) {
        result.push({
          name: components.tooltip,
          options: {
            value: this.tooltip,
            placement: popperPlacements.bottom
          }
        })
      }

      return result
    }
  },

  render
}
